/* global process */
import GoogleSocialAccount from '../SocialAccount/GoogleSocialAccount';
import MicrosoftSocialAccount from '../SocialAccount/MicrosoftSocialAccount';
import MobileApps from '../MobileApps/MobileApps';
import SitePreferences from '../SitePreferences';
import UpdatePassword from '../UpdatePassword';
import CustomizeQuickAccessBar from '../CustomizeQuickAccessBar';

const myProfileStructure = () => {
  const googleAccount = {
    id: 'googleAccount',
    icon: 'google3',
    title: 'Google Account',
    route: 'google-account',
    component: GoogleSocialAccount,
  };

  const microsoftAccount = {
    id: 'microsoftAccount',
    icon: 'windows8',
    title: 'Microsoft Account',
    route: 'microsoft-account',
    component: MicrosoftSocialAccount,
  };

  const mobileApps = {
    id: 'mobileApps',
    icon: 'mobile2',
    title: 'Mobile Apps',
    route: 'mobile-apps',
    component: MobileApps,
  };

  const MyProfileModuleStructure = [
    {
      id: 'accountSettings',
      title: 'Account Settings',
      route: 'account-settings',
      icon: 'cogs',
      children: [
        {
          id: 'sitePreferences',
          icon: 'equalizer3',
          title: 'Site Preferences',
          route: 'site-preferences',
          component: SitePreferences,
          withEntityFormEditButton: true,
        },
        {
          id: 'updatePassword',
          icon: 'lock5',
          title: 'Update Password',
          route: 'update-password',
          component: UpdatePassword,
        },
        {
          id: 'customizeQuickAccessBar',
          icon: 'hammer-wrench',
          title: 'Customize Quick Access Bar',
          route: 'customize-quick-access-bar',
          component: CustomizeQuickAccessBar,
        },
      ],
    },
  ];

  const isGoogleRender = process.env.BROWSER
    ? window.App.googleClientId
    : process.env.GOOGLE_CLIENT_ID;

  const isMicrosoftRender = process.env.BROWSER
    ? window.App.microsoftClientId
    : process.env.MICROSOFT_CLIENT_ID;

  if (isGoogleRender && isMicrosoftRender) {
    MyProfileModuleStructure[0].children = [
      ...MyProfileModuleStructure[0].children,
      [googleAccount, microsoftAccount, mobileApps],
    ];
    return MyProfileModuleStructure;
  } else if (isGoogleRender) {
    MyProfileModuleStructure[0].children = [
      ...MyProfileModuleStructure[0].children,
      [googleAccount, mobileApps],
    ];
    return MyProfileModuleStructure;
  } else if (isMicrosoftRender) {
    MyProfileModuleStructure[0].children = [
      ...MyProfileModuleStructure[0].children,
      [microsoftAccount, mobileApps],
    ];
    return MyProfileModuleStructure;
  }
  MyProfileModuleStructure[0].children = [
    ...MyProfileModuleStructure[0].children,
    [mobileApps],
  ];
  return MyProfileModuleStructure;
};

export default myProfileStructure;
